enum Errors {
    BadRequest				= "BAD_REQUEST",
	BadResponse				= "BAD_RESPONSE",
	OutOfDate				= "OUT_OF_DATE",
	UnsupportedMediaType    = "ERROR_UNSUPPORTED_MEDIA_TYPE",
	Forbidden			    = "FORBIDDEN",
	InternalService			= "INTERNAL_SERVICE",
	NotFound				= "NOT_FOUND",
	PreconditionFailed		= "PRECONDITION_FAILED",
	Timeout					= "TIMEOUT",
	Unauthorized			= "UNAUTHORIZED",
}

export default Errors;
